import React from 'react'
import { ListSubheader } from '@material-ui/core'
import { getLang } from '../../app/selectors/lang'
import { getSubjectFromMetricId } from '../../app/selectors/metrics'
import { SedaTimeseries } from '../../timeseries'
import { useAppContext } from '../../app/hooks'
import { TIMESERIES_X_EXTENTS } from '../../timeseries/constants'

const SedaLocationTimeseries = ({ location }) => {
  const {
    metric,
    demographic,
    region
  } = useAppContext()
  const subject = getSubjectFromMetricId(metric)
  const [start, end] = TIMESERIES_X_EXTENTS[region][subject]
  const group = getLang(`LABEL_STUDENTS_${demographic}`)
  const title = subject === "abs"
    ? getLang(`LOCATION_SUBHEADING_TIMESERIES_${subject}`, { start, end, group })
    : getLang(`LOCATION_SUBHEADING_TIMESERIES_${subject}`, { start, end, group })
  return (
    <>
      <ListSubheader>
        {title}
      </ListSubheader>
      <SedaTimeseries
        locationData={location}
      />
    </>
  )
}

SedaLocationTimeseries.propTypes = {

}

export default SedaLocationTimeseries
